import { Component, forwardRef, Host, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Log } from 'src/app/core/console.log';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { MasterService } from 'src/app/services/master.service';
import { DropdownFormControl } from 'src/app/shared/inputs/dropdown-form-control';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-dp-nationality',
  templateUrl: './input-dp-nationality.component.html',
  styleUrls: ['./input-dp-nationality.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpNationalityComponent),
      multi: true
    },
  ]
})
export class InputDpNationalityComponent extends DropdownFormControl implements OnInit {
  errors = inputMgsErrs.nationality;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private masterService: MasterService
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
    this.initDropdownList();
  }

  initDropdownList() {
    this.resetDropdownList();
    this.masterService.getNationality().subscribe((result: Array<DropdownModel>) => {
      this.items.push(...result);
      this.findValueFromList(this.value);
      this.setAfterLoadItemDropdown();
    }, error => {
      Log.error(error);
    });
  }

  resetDropdownList() {
    this.items = new Array<DropdownModel>();
  }

}
